import React from 'react'
import Layout from '../../components/layout/Layout'
import ProductCategoriesTable from '../../elements/tables/ecomm/ProductCategoriesTable'

export default function ProductCategroies() {
  return (
    <div>
      <Layout>
        <ProductCategoriesTable />
      </Layout>
    </div>
  )
}
